// extracted by mini-css-extract-plugin
export default {"btnContent":"buttonCarousel_btnContent__3vNjK","buttonImg":"buttonCarousel_buttonImg__Y4Nnp","btnText":"buttonCarousel_btnText__qHgHl"};